"use client"

import { MessageCircleQuestionMark } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `MessageCircleQuestionMarkIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const MessageCircleQuestionMarkIcon = component(Icon)({
  as: MessageCircleQuestionMark,
})
